import script from "./BarChart3.vue?vue&type=script&setup=true&lang=js"
export * from "./BarChart3.vue?vue&type=script&setup=true&lang=js"

import "./BarChart3.vue?vue&type=style&index=0&id=2bdb16c6&lang=less"

const __exports__ = script;

export default __exports__